import React, { useMemo } from 'react';
import Spinner from '../spinner/Spinner';
import { useTimeout } from 'usehooks-ts'

export default function PartsCatalogRedirect() {
  const params = new URLSearchParams(location.search);
  const catalogNumber = params.get('catalogNumber');
  const serialNumber = params.get('serialNumber');
  const modelNumber = params.get('modelNumber');

  const targetUrl = useMemo(() => {
    if (!!catalogNumber) {
      return `https://public-mercurymarine.sysonline.com/g3/?catnbr=${catalogNumber}&ui=full`
    } else if (!!serialNumber) {
      return `https://public-mercurymarine.sysonline.com/g3/?serial=${serialNumber}&ui=full`
    } else if (!!modelNumber) {
      return `https://public-mercurymarine.sysonline.com/g3/?mdlnbr=${modelNumber}&ui=full`
    }
  }, [catalogNumber, serialNumber, modelNumber]);

  useTimeout(() => {
    if (targetUrl) {
      window.location.href = targetUrl;
    }
  }, 500); // Redirect after half a second

  return (
    <div style={{ textAlign: 'center', width: '100%', marginTop: '1em' }}>
      Loading...
      <Spinner blackProp />
      <br />
      <span>If parts catalog does not automatically open click here <a href={targetUrl}>click here</a></span>
    </div>
  );
}